import React, { useEffect, useState } from 'react';
import i18n from '../../i18n';
import { auth, db } from '../../utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { readSettings, writeSettings } from '../../utils/settings';

export default function SettingsLanguage() {
  const [lang, setLang] = useState('tr');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async () => {
      setLoading(true);
      const { settings } = await readSettings(auth, db);
      setLang(settings.language || 'tr');
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return (
    <div className="bg-background-light dark:bg-background-dark min-h-screen">
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 max-w-5xl">
        <h1 className="text-2xl font-bold mb-4 text-text-dark dark:text-text-light">Dil Tercihi</h1>
        <div className="panel rounded-xl shadow p-6 space-y-4">
          <label className="block text-sm">Uygulama Dili</label>
          <select
            value={lang}
            disabled={loading}
            onChange={async (e)=>{
              const v = e.target.value; setLang(v);
              await writeSettings(auth, db, { language: v });
              try { i18n.changeLanguage(v); } catch {}
            }}
            className="px-3 py-2 rounded-lg bg-background-light dark:bg-background-dark border border-border-light dark:border-border-dark"
          >
            <option value="tr">Türkçe</option>
            <option value="en">English</option>
          </select>
        </div>
      </main>
    </div>
  );
}
